import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@react-pdf/renderer'

import { Status } from '@generators/pdfComponents/Status'
import { Box } from '@generators/pdfComponents/Box'
import { TresholdDisplay } from '@generators/pdfComponents/ThresholdDisplay'
import { getTresholdValue } from '@util/tresholdUtil'
import { statusColors } from '@generators/tresholdConstants'

export const CharacteristicStatus = ({ value, type }) => {
  const category = getTresholdValue(type, value)

  return (
    <View
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      <View>
        <Status
          text={category}
          backgroundColor={`${statusColors[category]}1A`}
          textColor={statusColors[category]}
          style={{ marginRight: 24 }}
        />
      </View>
      <Box width={223.5}>
        <TresholdDisplay value={value} type={type} />
      </Box>
    </View>
  )
}

CharacteristicStatus.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string.isRequired,
}

CharacteristicStatus.defaultProps = {
  value: null,
}
